export class Formula {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                    expression = '',
                    rounding_options = {
                        decimal: {enabled: false, direction: {intermediate: "auto", total: "auto" },"apply_to": "all"}, 
                        even: { enabled: false, direction: {intermediate: "auto", total: "auto" },"apply_to": "all" } 
                    },
                    type = null,
                    created_at = new Date(),
                    updated_at = new Date(),
                    deleted_at = null,

                    //relations
                    product_option_id = null,
                    custom_product_id = null
                } = {}) {
        this.id = id;
        this.company_id = company_id;
        this.name = name;
        this.expression = expression;
        this.rounding_options = rounding_options || { 
            decimal: {enabled: false, direction: {intermediate: "auto", total: "auto" },"apply_to": "all"}, 
            even: { enabled: false, direction: {intermediate: "auto", total: "auto" },"apply_to": "all" } 
        };

       
        this.type = type;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;

        this.product_option_id = product_option_id;
        this.custom_product_id = custom_product_id;
    }

}

export function createFormula(data={}) {
    return Object.freeze(new Formula(data));
}